import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function downloadReports(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.DOWNLOAD_EQUIPMENT_REPORTS_REQUEST,
			payload: {
				loading: true,
				hasDownloadSuccess: false
			}
		});

		let response = await API.report.downloadEquipmentReports(options);

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.DOWNLOAD_EQUIPMENT_REPORTS_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
		}
		const {csv_string} = response.data;
		dispatch({
			type: ActionTypes.DOWNLOAD_EQUIPMENT_REPORTS_SUCCESS,
			payload: {
				csv_string,
				meta: response.meta,
				loadingDownloadSubmit: false,
				hasDownloadSuccess: true
			}
		});
	};
}
